import React from 'react';
import Stack from '@mui/material/Stack';
import { CountryFlag, colorPalette } from '@next-common/mui';
import { Section } from '../Section';
import { SellerBio } from './SellerBio';
import { InfoTypography } from './Seller.style';
export const SellerProfile = ({ seller }) => {
    var _a, _b, _c, _d;
    const formatSellerAnswerTime = (milliseconds) => {
        const minutes = milliseconds / 60000; // Convert milliseconds to minutes
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = Math.round(minutes % 60);
        return `${hours}h ${remainingMinutes}min`;
    };
    return (React.createElement(Section, { spacing: 1 },
        React.createElement(SellerBio, { seller: seller }),
        React.createElement(Stack, { direction: "row", width: "100%", justifyContent: "space-between" },
            React.createElement(InfoTypography, null, "Membre depuis"),
            React.createElement(InfoTypography, null,
                "le ",
                new Date((seller === null || seller === void 0 ? void 0 : seller.creationDate) || 0).toLocaleDateString())),
        React.createElement(Stack, { direction: "row", width: "100%", justifyContent: "space-between" },
            React.createElement(InfoTypography, null, "Temps de r\u00E9ponse"),
            React.createElement(InfoTypography, null, formatSellerAnswerTime(((seller === null || seller === void 0 ? void 0 : seller.sellerAnswerTime) || 0) / 100000))),
        React.createElement(Stack, { direction: "row", width: "100%", justifyContent: "space-between" },
            React.createElement(InfoTypography, null, "Taux d'acceptation"),
            React.createElement(InfoTypography, null, seller === null || seller === void 0 ? void 0 : seller.acceptanceRate)),
        ((_b = (_a = seller === null || seller === void 0 ? void 0 : seller.legalNotice) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.countryName) && (React.createElement(Stack, { direction: "row", width: "100%", justifyContent: "space-between", alignItems: "center" },
            React.createElement(InfoTypography, null, "Pays d\u2019exp\u00E9dition"),
            React.createElement(CountryFlag, { cssClassFlag: {
                    marginRight: '0',
                    boxShadow: 'none',
                }, cssClassTitle: {
                    fontSize: '14px',
                    color: colorPalette.gray700,
                }, isoCode: (seller === null || seller === void 0 ? void 0 : seller.sellerCountry) || 0, countryName: ((_d = (_c = seller === null || seller === void 0 ? void 0 : seller.legalNotice) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.countryName) || '' })))));
};
